import { useEffect, useMemo, useRef, useState } from 'react';
import ReactModal from 'react-modal';

import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import Button from 'components/ui/button';
import { useAuth } from 'context/AuthContext';
import { actionLog } from 'services/actionlog.service';
import { RegulamentoContent } from 'components/regulamento-content';
import { getStorageItem, removeStorageItem, setStorageItem } from 'utils/storage';
import { checkInvite } from 'services/dashboard.service';
import { getRegulation, IRegulation } from 'services/regulation.service';

// interface RegulamentoModalProps {
//   on
// }

export function RegulamentoModal(props: any) {
  // const modalID = "achievement";

  // const modalID = 'help-pontos';

  const [modalIsOpen, setIsOpen] = useState(false);
  const [isAccept, setIsAccept] = useState(false);

  const [step, setStep] = useState(1);

  const { signOut, refreshUserPromise, user, userInfo, realCycle } = useAuth();

  // const { openModal, closeModal } = useContext(ModalContext);

  const acceptRef = useRef<any>();

  const [accept, setAccept] = useState(false);
  const [challenge, setChallenge] = useState(true);
  const [challengeDecline, setChallengeDecline] = useState(true);
  const [task, setTask] = useState(true);
  const [taskDecline, setTaskDecline] = useState(true);
  const [recognition, setRecognition] = useState(true);
  const [recognitionDecline, setRecognitionDecline] = useState(true);
  const [pageLoading, setPageLoading] = useState(false);
  const [decline, setDecline] = useState(false);
  const [regulation, setRegulation] = useState<IRegulation>();

  const [willOpen, setWillOpen] = useState(true);

  ReactModal.setAppElement('#modal');

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  function handleAccept(e: any) {
    setAccept(e.target.checked);
  }

  async function handleSubmit() {
    const readOnly = localStorage.getItem('readOnly');

    if (!user) return;
    if (!readOnly) setPageLoading(true);
    setIsOpen(false);
    setIsAccept(true);
    setStorageItem('accept', 'true');

    await actionLog('me', 'accept_rules', {
      task,
      actions: challenge,
      recognition,
    });

    const sender = getStorageItem('jogajuntobb_invite_code');

    if (typeof sender === 'string') {
      const hasInvite = await checkInvite(user._id, sender);

      if (hasInvite) {
        await actionLog('me', 'accept_invite', { sender });
      }

      removeStorageItem('jogajuntobb_invite_code');
    }

    await refreshUserPromise();

    setPageLoading(false);
  }

  function verifyPreference() {
    if (((!task || !recognition || !challenge) && !decline) || !accept) return true;

    return false;
  }

  useEffect(() => {
    // userInfo?.cad_missao === 0 || userInfo?.tipo_ro === 'GERENCIAL' || user?.extra?.tutorial
    if (user && !isAccept) {
      const readOnly = localStorage.getItem('readOnly');
      const _accept = localStorage.getItem('accept');

      // if (userInfo?.cad_missao === 0 || userInfo?.tipo_ro === 'GERENCIAL')

      setStep(userInfo?.cad_missao === 0 || userInfo?.tipo_ro === 'GERENCIAL' || userInfo?.is_manager ? 2 : 1);

      if (readOnly && _accept) {
        setIsOpen(false);
        return;
      }

      try {
        setIsOpen(!user.extra.accept);

        if (!user.extra.accept) {
          loadData();
        }
      } catch (e) {
        setIsOpen(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, userInfo, isAccept]);

  async function loadData() {
    const data = await getRegulation(user?.extra?.rede);
    if (data) {
      setRegulation(data);
    }
  }

  const currentCycle = useMemo(() => {
    if (!realCycle) return undefined;
    const cycle = realCycle.find((item: any) => item.status === 'open');

    return !!cycle ? cycle : realCycle[0];
  }, [realCycle]);

  function getText(): string {
    const parts = [];
    if (!recognition) parts.push('Reconhecimento');
    if (!task) parts.push('Realizações');
    if (!challenge) parts.push('Ações de Engajamento');

    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0];
    if (parts.length === 2) return parts.join(' e ');

    return `${parts.slice(0, -1).join(', ')} e ${parts[parts.length - 1]}`;
  }

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Example Modal"
        portalClassName="relative z-50"
        overlayClassName="fixed z-100 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
        contentElement={() => (
          <div>
            <div className="max-w-[900px] bg-blue-dark text-white rounded-xl p-4 lg:p-10 flex flex-col items-center space-y-2 flex-none mx-5">
              {step === 1 && (
                <>
                  <div className="mb-3 w-[105%]">
                    <h1 className="text-center text-yellow text-3xl mb-4">Minhas Preferências</h1>

                    <p className="text-center text-lg mb-4">
                      O Joga Junto possui 3 dinâmicas que você participa. <br /> Caso você não queira participar de alguma delas,
                      desmarque a dinâmica e confirme o termo de recusa. <br /> Você pode modificar essas preferências a qualquer momento
                      até {currentCycle?.date_end && format(new Date(currentCycle?.date_end), 'dd/MM/yyyy', { locale: ptBR })}
                    </p>

                    {/* Preferência de Reconhecimento */}
                    <div className="p-3 border-b border-gray-200">
                      <label className="cursor-pointer text-center flex items-center">
                        <input
                          type="checkbox"
                          name="acceptRecognition"
                          className="mr-2"
                          checked={recognition}
                          onChange={e => setRecognition(e.target.checked)}
                          ref={ref => {
                            acceptRef.current = ref;
                          }}
                        />
                        Dinâmica de Reconhecimento
                      </label>
                    </div>

                    {/* Preferência de Realizações */}
                    <div className="p-3 border-b border-gray-200">
                      <label className="cursor-pointer text-center flex items-center">
                        <input
                          type="checkbox"
                          name="acceptTask"
                          className="mr-2"
                          checked={task}
                          onChange={e => setTask(e.target.checked)}
                          ref={ref => {
                            acceptRef.current = ref;
                          }}
                        />
                        Dinâmica de Realizações
                      </label>
                    </div>

                    {/* Preferência de Engajamento */}
                    <div className="p-3">
                      <label className="cursor-pointer text-center flex items-center">
                        <input
                          type="checkbox"
                          name="acceptChallenge"
                          className="mr-2"
                          checked={challenge}
                          onChange={e => setChallenge(e.target.checked)}
                          ref={ref => {
                            acceptRef.current = ref;
                          }}
                        />
                        Dinâmica de Ações de Engajamento (Ações Ecoa, Desafio Semestral e Bônus de colaboração)
                      </label>
                    </div>

                    <div className="mt-2 p-3">
                      {(!recognition || !challenge || !task) && (
                        <div className="mt-2 space-y-2">
                          <p className="mr-2 text-sm text-yellow">
                            Conforme Solicitação de Exclusão do Programa Joga Junto BB, os pontos obtidos nessa dinâmica não serão
                            convertidos em premiação.
                          </p>
                          <div className="space-y-2">
                            <label className="cursor-pointer text-center flex items-center">
                              <input
                                type="checkbox"
                                name="acceptRecognitionDecline"
                                className="mr-2"
                                checked={decline}
                                onChange={e => setDecline(e.target.checked)}
                                ref={ref => {
                                  acceptRef.current = ref;
                                }}
                              />
                              Confirmo que estou ciente do termo de renúncia abaixo.
                            </label>

                            <b className="block">SOLICITAÇÃO DE EXCLUSÃO DO PROGRAMA JOGA JUNTO BB</b>
                            <p>
                              Solicito, para os devidos fins, minha exclusão do Programa Joga Junto BB referente ao Ciclo{' '}
                              {currentCycle?.title}.
                            </p>
                            <p>
                              Estou ciente de que minha solicitação de exclusão na(s) Dinâmica(s) ({`${getText()}`}), é
                              irrevogável e irretratável e implica na perda do meu direito a participar das premiações oferecidas
                              no Programa Joga Junto BB durante o semestre acima citado.
                            </p>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="text-center mt-4 text-sm p-3">
                      <label className="cursor-pointer text-center flex justify-center items-center mt-2">
                        <input
                          id="accept"
                          type="checkbox"
                          name="accept"
                          className="mr-1"
                          onChange={handleAccept}
                          ref={ref => {
                            acceptRef.current = ref;
                          }}
                        />
                        Concordo com os
                        <a className="mx-1 text-blue-700 underline" href={regulation?.url} target="_blank" rel="noreferrer">
                          termos e condições do regulamento
                        </a>
                        das preferências selecionadas.
                      </label>
                    </div>

                    {/* <p className="">
                      Concordo com os termos e condições do Regulamento das preferências selecionadas.
                    </p> */}
                  </div>

                  {/* Botões de Ação */}
                  <div className="flex flex-row justify-center space-x-4 mt-4">
                    <Button className="leading-none p-2" onClick={() => signOut()}>
                      Cancelar
                    </Button>
                    <Button
                      color="clear"
                      className="leading-none disabled:opacity-50 p-2 bg-yellow text-blue-dark"
                      disabled={verifyPreference()}
                      onClick={() => handleSubmit()}
                    >
                      Salvar Preferências
                    </Button>
                  </div>
                </>
              )}

              {step === 2 && (
                <>
                  <div className="mb-3 w-[105%]">
                    <h1 className="text-center text-yellow text-2xl mb-2">Regulamento</h1>

                    <div className="space-y-5 lg:p-3 h-[35vh] overflow-y-auto mb-4">
                      <RegulamentoContent modal rede={user?.extra.rede} />
                    </div>

                    <div className="border-2 border-yellow rounded-lg p-3">
                      <label className="cursor-pointer text-center">
                        <input
                          id="accept"
                          type="checkbox"
                          name="accept"
                          className="mr-1"
                          onChange={e => handleAccept(e)}
                          ref={ref => {
                            acceptRef.current = ref;
                          }}
                        />{' '}
                        Concordo com os termos e condições do regulamento do #JogaJuntoBB
                      </label>
                    </div>
                  </div>

                  <div className="flex flex-row space-x-4">
                    <Button className="leading-none p-2" onClick={() => signOut()}>
                      Sair do #JogaJuntoBB
                    </Button>
                    <Button
                      color="clear"
                      className="leading-none disabled:opacity-50 p-2  bg-yellow text-blue-dark"
                      disabled={!accept}
                      onClick={() => handleSubmit()}
                    >
                      Confirmar participação
                    </Button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      />

      {pageLoading && (
        <div className="fixed z-40 w-full h-full top-0 left-0 block flex items-center justify-center bg-black bg-opacity-60">
          <div role="status" className="flex items-center justify-center flex-col space-y-2 text-white">
            <svg
              aria-hidden="true"
              className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span className="text-white">Atualizando Preferências...</span>
          </div>
        </div>
      )}
    </>
  );
}
